import { render, staticRenderFns } from "./MainPageVideo.vue?vue&type=template&id=51ccf93e&scoped=true&"
import script from "./MainPageVideo.vue?vue&type=script&lang=js&"
export * from "./MainPageVideo.vue?vue&type=script&lang=js&"
import style0 from "./MainPageVideo.vue?vue&type=style&index=0&id=51ccf93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccf93e",
  null
  
)

export default component.exports